import React from "react";
import { Container, FormContainer, OuterContainer } from "./styles";
import { Formik } from "formik";
import {
  Paper,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import styled from "styled-components";
import theme from "../../../../assets/theme";
import { PrimaryCTAButton } from "../../../common/Buttons";
import FormField from "../../../schedules/FormInputs";
import useLoader from "../../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../../services/EventService";

const LivePolls = ({ pollQuestions, eventId, setTriggerCall }) => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();

  const live_polls_inputs = [
    {
      name: "pushQuestionNumber",
      label: "Push Question Number",
      type: "select",
    },
    // { name: "pushRollResults", label: "Push Poll Results", type: "select" },
    {
      name: "acceptingResponse",
      label: "Accepting Response",
      type: "radio",
      menuItems: [
        {
          name: "notAccept",
          value: "notAccept",
          label: "Not Accepting",
          empty: "",
        },
        {
          name: "pollsAreLive",
          value: "pollsAreLive",
          label: "Polls are Live",
        },
      ],
    },
  ];

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "push poll question..." });
      const payload = {
        pollQuestions: values?.pollQuestions?.map((item) => ({
          ...item,
          accept:
            values?.livePolls?.pushQuestionNumber === item?.question
              ? values?.livePolls?.acceptingResponse
              : item.accept,
        })),
      };
      const response = await EventService.updateEvent(eventId, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      setTriggerCall(true);
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  return (
    <OuterContainer>
      <Container>
        <Formik
          initialValues={{
            pollQuestions: pollQuestions?.length
              ? pollQuestions?.map((item) => ({
                  question: item?.question,
                  options: item?.options,
                  disabled: item?.accept === "notAccept" ? true : false,
                  accept: item?.accept,
                }))
              : [
                  {
                    question: "None",
                    options: ["none"],
                    disabled: false,
                    accept: "",
                  },
                ],
            livePolls: {
              pushQuestionNumber: "",
              pushRollResults: "",
              acceptingResponse: "",
            },
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnBlur
          validateOnChange
          validationSchema={""}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            setFieldValue,
            handleSubmit,
            resetForm,
          }) => (
            <FormContainer>
              <Paper
                elevation={3}
                style={{
                  padding: 16,
                  border: "1px solid #e1e3ee",
                  marginTop: "15px",
                  marginBottom: "15px",
                  borderRadius: "8px",
                }}
              >
                <GridLabel>Live Polls</GridLabel>
                <Grid
                  container
                  item
                  xs={12}
                  spacing={3}
                  style={{ padding: 16 }}
                >
                  {live_polls_inputs.map((item, idx) => (
                    <Grid
                      item
                      xs={isBigScreen ? 6 : 12}
                      key={item.name}
                      style={styles.gridItem}
                    >
                      <FormField
                        {...{ item, values, errors, touched }}
                        handleChange={(e) => {
                          if (item.name === "pushQuestionNumber") {
                            setFieldValue(
                              `livePolls.${item.name}`,
                              e.target.value,
                            );
                            setFieldValue(`livePolls.acceptingResponse`, "");
                          } else {
                            setFieldValue(
                              `livePolls.${item.name}`,
                              e.target.value,
                            );
                          }
                        }}
                        name={`livePolls.${item.name}`}
                        menuItems={
                          item.name === "pushQuestionNumber"
                            ? values?.pollQuestions.map((item) => ({
                                label: item.question,
                                value: item.question,
                                disabled: item.disabled,
                                accept: item.accept,
                              }))
                            : item.name === "acceptingResponse"
                            ? item?.menuItems?.map((find) => ({
                                label: find.label,
                                name: find.name,
                                value: find.value,
                                disabled:
                                  values?.pollQuestions.find(
                                    (item) =>
                                      item.question ===
                                      values?.livePolls?.pushQuestionNumber,
                                  )?.accept === "notAccept"
                                    ? true 
                                    : values?.pollQuestions.find(
                                        (item) =>
                                          item.question ===
                                          values?.livePolls?.pushQuestionNumber,
                                      )?.accept === "pollsAreLive"
                                    ? find.name === "pollsAreLive" 
                                    : values?.pollQuestions.find(
                                        (item) =>
                                          item.question ===
                                          values?.livePolls?.pushQuestionNumber,
                                      )?.accept === ""
                                    ? find.name === "notAccept" 
                                    : false, 
                              }))
                            : item.menuItems
                        }
                        value={values.livePolls[item.name]}
                        direction={"row"}
                      />
                    </Grid>
                  ))}
                </Grid>
                <PrimaryCTAButton
                  style={{ width: "auto", marginLeft: "24px" }}
                  onClick={handleSubmit}
                >
                  Push Live
                </PrimaryCTAButton>
              </Paper>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

export default LivePolls;

const GridLabel = styled(Typography)(() => ({
  width: "250px",
  color: " #00838c",
  fontSize: "15px",
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "15px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));
